import { render, staticRenderFns } from "./FeedbackTable.vue?vue&type=template&id=315ecacb&scoped=true&"
import script from "./FeedbackTable.vue?vue&type=script&lang=ts&"
export * from "./FeedbackTable.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackTable.vue?vue&type=style&index=0&id=315ecacb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315ecacb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import GFaIcon from 'shared/global/components/FaIcon.vue'
import GOverflowTooltip from 'shared/global/components/OverflowTooltip.vue'
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
installComponents(component, {GFaIcon,GOverflowTooltip,VBtn,VDataTable})
